import { environment } from '../../../environments/environment';

export const PlannerEndpoints = {
    // configuration
    advertiserList: environment.ccpApiUrl + '/ccp/configuration/advertiserList',
    planCRUD: environment.ccpApiUrl + '/ccp/configuration/crud',
    planDetail: environment.ccpApiUrl + '/ccp/configuration/details/',
    planConfigList: environment.ccpApiUrl + '/ccp/configuration/list',
    planGenerate: environment.ccpApiUrl + '/ccp/configuration/generate',
    planActivate: environment.ccpApiUrl + '/ccp/configuration/activate',
    planArchive: environment.ccpApiUrl + '/ccp/configuration/archive',
    planCopy: environment.ccpApiUrl + '/ccp/configuration/copy',
    planAccount: environment.ccpApiUrl + '/ccp/configuration/planAccounts',
    planLabel: environment.ccpApiUrl + '/ccp/configuration/labels',
    planForecast: environment.ccpApiUrl + 'ccp/configuration/planForecast',
    planResult: environment.ccpApiUrl + '/ccp/configuration/result/',
    planDefault: environment.ccpApiUrl + '/ccp/configuration/buildDefaultPlan',
    planForecastBlueprint: environment.ccpApiUrl + '/ccp/configuration/forecastBluePrint/',
    planInventoryAllocationExport: environment.ccpApiUrl + '/ccp/export/plan/',
    // dspIntegration
    dspAdvertisers: environment.ccpApiUrl + '/ccp/dspIntegration/advertisers',
    dspMarkets: environment.ccpApiUrl + '/ccp/dspIntegration/markets',
    dspRtbExchanges: environment.ccpApiUrl + '/ccp/dspIntegration/availableRtbExchanges',
    dspDeals: environment.ccpApiUrl + '/ccp/dspIntegration/availableDeals?mediaChannelId=2',
    dspDealExchanges: environment.ccpApiUrl + '/ccp/dspIntegration/dealExchanges',
    tpaPlatforms: environment.ccpApiUrl + '/ccp/dspIntegration/getTpaPlatforms',

    // console (this is coming from console)
    segments: environment.dspApiUrl + '/ccpIntegration/audience/segments',
    concepts: environment.dspApiUrl + '/ccpIntegration/audience/concepts',
    conceptSets: environment.dspApiUrl + '/ccpIntegration/audience/conceptSets',
    marketSiteList: environment.dspApiUrl + '/ccpIntegration/targeting/marketSiteList',
    continents: environment.dspApiUrl + '/ccpIntegration/targeting/geo/continents',
    geoBase: environment.dspApiUrl + '/ccpIntegration/targeting/geo/',
};
